import { createFileRoute } from '@tanstack/react-router';

import { SupplierStatementPage } from '@/features/supplier/statement-page';

export const Route = createFileRoute('/_app/supplier/$orgId/customers/$customerId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierStatementPage {...params} />;
}
